import { Loader, SelectGeneric } from 'ypf-pas-general-ui-components';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';

import useToast from '../../../../../../hooks/useToast';
import AccountAssignmentObjectDetail from '../../../../../Wells/AccountAssignmentObjectDetail/AccountAssignmentObjectDetail';
import styles from '../../../../../WorkReportModals/ImputationModal/ImputationModal.module.scss';
import { getImputationObjectVEApprover } from '../../../../../../services/workReport';
import { mapperImputationDefault } from '../../../../../../utils/mapper';
import { imputationTypeEnum } from '../../../../../../utils/dataStatus';
import {
  getBudgetService,
  getImputationsDetails,
  getImputationsObjects,
  getImputationType
} from '../../../../../../services/yclickMaster';

import HeaderDetailVE from './HeaderDertailVE';

const ImputationObjectDetailVE = (props) => {
  const {
    values,
    setFieldValue,
    fechaRealizacionDesde,
    fechaRealizacionHasta,
    idsParteDiario,
    nroLinea,
    nroPosicion,
    showModal,
    loading,
    setLoading,
    title
  } = props;

  const [imputationTypeOptions, setImputationTypeOptions] = useState([]);
  const [noOptions, setNoOptions] = useState('Ingresar al menos 5 caracteres');
  const { setNewToast } = useToast();
  const [showAlert, setShowAlert] = useState(false);

  const adaptData = async (dataToAdapt) => {
    let budget = {};

    const details = mapperImputationDefault(
      dataToAdapt.detalleObjeto,
      dataToAdapt.tipoObjetoImputacion
    );

    if (dataToAdapt.tipoObjetoImputacion?.id === imputationTypeEnum.PEP) {
      budget = await getBudgetService(dataToAdapt.objetoImputacion?.id);
    }

    return {
      ...details,
      pozoId: dataToAdapt?.detalleObjeto?.pozoId,
      budget: budget?.presupuesto || null,
      warningBudget: (budget && budget?.presupuesto >= 10000) || false
    };
  };

  const getDetailsImputationObject = async () => {
    try {
      setLoading(true);
      const res = await getImputationObjectVEApprover({
        fechaRealizacionDesde,
        fechaRealizacionHasta,
        idsParteDiario,
        nroLinea,
        nroPosicion
      });

      if (res?.data.length) {
        const dataImputation = res.data[0];

        const resAdapted = await adaptData(dataImputation);
        const mappedImputationType = {
          id: dataImputation?.tipoObjetoImputacion?.id,
          nombre: dataImputation?.tipoObjetoImputacion?.nombre,
          descripcion: null,
          value: dataImputation?.tipoObjetoImputacion?.id,
          label: dataImputation?.tipoObjetoImputacion?.nombre
        };
        const mappedImputationObject = {
          id: dataImputation?.objetoImputacion?.id,
          nombre: dataImputation?.objetoImputacion?.nombre,
          descripcion: dataImputation?.objetoImputacion?.descripcion,
          value: dataImputation?.objetoImputacion?.id,
          label: `${dataImputation?.objetoImputacion?.nombre} | ${dataImputation?.objetoImputacion?.descripcion}`
        };

        const isPep = dataImputation?.tipoObjetoImputacion?.id === imputationTypeEnum.PEP;

        setShowAlert(
          dataImputation?.detalleObjeto?.alerta ||
            (resAdapted?.warningState && isPep) ||
            (!resAdapted?.logisticCenter && !resAdapted?.socCode)
        );

        setFieldValue('initialImputationObject', mappedImputationObject);
        setFieldValue('initialImputationType', mappedImputationType);
        setFieldValue('pozoId', dataImputation?.detalleObjeto?.pozoId);
        setFieldValue('imputationObject', mappedImputationObject);
        setFieldValue('imputationType', mappedImputationType);
        setFieldValue('detailObject', resAdapted);
      }
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchPreviewDetail = async (object) => {
    try {
      if (!object) {
        setFieldValue('imputationObject', {});

        return;
      }
      setLoading(true);
      const res = await getImputationsDetails([
        {
          tipoId: values?.imputationType.id,
          objetoId: object.id
        }
      ]);

      const dataToAdapt = {
        detalleObjeto: res[0],
        objetoImputacion: object,
        tipoObjetoImputacion: values?.imputationType
      };

      const resAdapted = await adaptData(dataToAdapt);

      const isPep = values?.imputationType?.id === imputationTypeEnum.PEP;

      setShowAlert(
        dataToAdapt?.detalleObjeto?.alerta ||
          (resAdapted?.warningState && isPep) ||
          (!resAdapted?.logisticCenter && !resAdapted?.socCode)
      );

      setFieldValue('detailObject', resAdapted);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    }
  };

  const fetchDataObjects = async (type, searchValue) => {
    if (searchValue.length < 5) {
      setNoOptions('Ingresar al menos 5 caracteres');

      return null;
    }
    try {
      const objectResponse = await getImputationsObjects(type.id, searchValue);

      setNoOptions('Sin opciones');

      return objectResponse.map((res) => ({
        id: res.id,
        nombre: res.codigo && res.descripcion ? `${res.codigo} | ${res.descripcion}` : undefined
      }));
    } catch (err) {
      return null;
    }
  };

  const fetchImputationTypeOptions = async () => {
    try {
      setLoading(true);
      const options = await getImputationType();

      setImputationTypeOptions(options);
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (showModal) {
      fetchImputationTypeOptions();
      getDetailsImputationObject();
    }

    if (!showModal) {
      setFieldValue('imputationType', null);
      setFieldValue('imputationObject', null);
      setFieldValue('detailObject', null);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {showAlert && (
        <div className={styles['warning-container']}>
          <p className={styles['warning-message']}>
            El objeto de imputacion presenta inconvenientes, se envia como excepcion YCLICK
          </p>
        </div>
      )}
      <HeaderDetailVE title={title} />
      <div className={styles['imputation-container']}>
        <Row>
          <Col sm={3}>
            <SelectGeneric
              label="Tipo de imputación *"
              name="imputationType"
              onChange={(newValue) => {
                setFieldValue('imputationType', newValue);
                setFieldValue('imputationObject', {});
              }}
              options={imputationTypeOptions}
              paddingIndicator={4}
              placeholder="Tipo imputación"
              value={values?.imputationType}
              withSelect="100%"
            />
          </Col>
          <Col sm={9}>
            <SelectGeneric
              async
              fetchData={(searchValue) => fetchDataObjects(values?.imputationType, searchValue)}
              isDisabled={!values?.imputationType}
              label="Objeto de imputación | Denominación objeto *"
              name="imputationObject"
              noOptionsMessage={noOptions}
              onChange={(newValue) => {
                setFieldValue('imputationObject', newValue);
                fetchPreviewDetail(newValue);
              }}
              paddingIndicator={4}
              placeholder="Buscar por nombre"
              value={values?.imputationObject}
              withSelect="100%"
            />
          </Col>
        </Row>
        <AccountAssignmentObjectDetail data={values?.detailObject} societyLabel={false} />
      </div>
      <Loader show={loading} text="CARGANDO" />
    </>
  );
};

export default ImputationObjectDetailVE;

ImputationObjectDetailVE.propTypes = {
  values: PropTypes.shape({
    imputationType: PropTypes.shape({
      id: PropTypes.number,
      nombre: PropTypes.string,
      value: PropTypes.number
    }),
    imputationObject: PropTypes.shape({
      id: PropTypes.number,
      nombre: PropTypes.string,
      value: PropTypes.number
    }),
    detailObject: PropTypes.shape({
      socCode: PropTypes.string,
      logisticCenter: PropTypes.string,
      pozoId: PropTypes.number,
      budget: PropTypes.number,
      warningBudget: PropTypes.bool
    })
  }).isRequired,
  setFieldValue: PropTypes.func,
  fechaRealizacionDesde: PropTypes.string.isRequired,
  fechaRealizacionHasta: PropTypes.string.isRequired,
  idsParteDiario: PropTypes.arrayOf(PropTypes.number).isRequired,
  nroLinea: PropTypes.number.isRequired,
  nroPosicion: PropTypes.number.isRequired,
  showModal: PropTypes.bool,
  loading: PropTypes.bool,
  setLoading: PropTypes.func,
  title: PropTypes.string.isRequired
};

ImputationObjectDetailVE.defaultProps = {
  setFieldValue: () => {},
  showModal: false,
  loading: false,
  setLoading: () => {}
};
